import React, { ReactNode } from 'react'
import styles from './List.module.css'
import { NumberOfRecords } from '../NumberOfRecords'
// @ts-ignore
import PageList from '../../withPagination/PageList'

export function ListFilters ({ recordCount }: { recordCount: ReactNode }) {
  return (
    <div className={styles.filters}>
      <NumberOfRecords>{recordCount}</NumberOfRecords>
    </div>
  )
}

export type PaginationProps = {
  currentPage: number
  pageCount: number
  onPageClick: (page: number) => void
}
export function Pagination ({
  currentPage,
  pageCount,
  onPageClick
}: PaginationProps) {
  return (
    <PageList
      // @ts-ignore
      pagination={{ first: 1, last: pageCount, current: currentPage }}
      updateSearchParams={({ pagination }: any) =>
        onPageClick(pagination.current)
      }
    />
  )
}
